import { render, staticRenderFns } from "./CriteriaCompare.vue?vue&type=template&id=1c06ebbe&scoped=true"
import script from "./CriteriaCompare.vue?vue&type=script&lang=js"
export * from "./CriteriaCompare.vue?vue&type=script&lang=js"
import style0 from "./CriteriaCompare.vue?vue&type=style&index=0&id=1c06ebbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c06ebbe",
  null
  
)

export default component.exports